module.exports = __webpack_public_path__ + "img/image-001.952ae787.jpg";